import { FontFamily } from '../enums/ElementProperties';

export const EL_FONT_FAMILY = [FontFamily.Arial, FontFamily.Helvetica, FontFamily.TimesNewRoman];
